import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
//import List from "@material-ui/core/List";
//import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// import Favorite from "@material-ui/icons/Favorite";
// core components
import Header from "components/static/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/static/Parallax/Parallax.jsx";
import Footer from "components/static/Footer/Footer.jsx";
import FooterLinks from "components/static/Footer/FooterLinks.jsx";
// sections for this page
import HeaderLinks from "components/static/Header/HeaderLinks.jsx";
import SectionDescription from "views/static/about-us/Sections/SectionDescription.jsx";
import SectionServices from "views/static/about-us/Sections/SectionServices.jsx";
import SectionOffice from "views/static/about-us/Sections/SectionOffice.jsx";
import SectionContact from "views/static/about-us/Sections/SectionContact.jsx";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx";

class AboutUsPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header
          brand="Kinos Corp"
          links={<HeaderLinks dropdownHoverColor="info" />}
          fixed
          color="transparent"
          changeColorOnScroll={{
            height: 300,
            color: "info"
          }}
        />
      <Parallax image={require("assets/img/torus/about.jpeg")} filter="dark" small>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem
                md={8}
                sm={8}
                className={classNames(
                  classes.mlAuto,
                  classes.mrAuto,
                  classes.textCenter
                )}
              >
                <h1 className={classes.title}>Know us</h1>
                <h4>
                  Expertise across all real estate sectors
                </h4>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <SectionDescription />
            <SectionOffice />
            <SectionServices />
            <SectionContact />
          </div>
        </div>
        <Footer>
          <FooterLinks/>
        </Footer>

      </div>
    );
  }
}

export default withStyles(aboutUsStyle)(AboutUsPage);
